const LocationBadge = ({ area, name, toggleById, _id, toggle }) => {
  return (
    <div className="w-full h-30px pl-3 z-200">
      <div className="flex items-center space-x-2">
        <button
          onClick={() => toggleById(_id)}
          className="p-1 rounded w-8 mr-2 hover:bg-gray-100 transition"
        >
          {toggle ? (
            <i className={`fas fa-chevron-down text-gray-300`}></i>
          ) : (
            <i className={`fas fa-chevron-right text-gray-300`}></i>
          )}
        </button>

        <span
          className={`inline-block ${
            _id == "timeoff" ? "bg-gray-500" : "bg-blue-500"
          } text-white text-xs font-semibold px-2 py-0.5 rounded`}
        >
          {area}
        </span>

        <span className="text-sm text-semibold text-slate-700">{name}</span>
      </div>
    </div>
  );
};

export default LocationBadge;
